/**
 * @file: index.tsx
 *
 * `ChatContactPickerScreen` — the navigator binding for the contact picker:
 * it mounts `ChatContactPickerView` and routes its outcome (a new group opens
 * the conversation; an invite/cancel pops back). The view itself
 * (re-exported here) is navigation-agnostic and lives in `./components`.
 */

import { ChatContactPickerParams } from '@euler/app/flows/chat/lib/types';
import type { ChatNavParams } from '@euler/app/flows/chat/screens';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { useNavigation } from '@react-navigation/native';
import { StackNavigationProp } from '@react-navigation/stack';
import { ChatContactPickerView } from './components/ChatContactPickerView';

export { ChatContactPickerView };

export const ChatContactPickerScreen = wrapNavigatorScreen(
  (params: ChatContactPickerParams) => {
    const navigation = useNavigation<StackNavigationProp<ChatNavParams>>();
    return (
      <ChatContactPickerView
        params={params}
        onCancel={() => navigation.goBack()}
        onDone={result => {
          if (result.kind === 'new-group') {
            navigation.replace('_chatConversation' as any, {
              kind: 'room',
              roomId: result.roomId,
            });
          } else {
            navigation.goBack();
          }
        }}
      />
    );
  },
  { headerShown: false },
);
